import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import {ClipboardModule} from '@angular/cdk/clipboard';
import {MatTabsModule} from '@angular/material/tabs';
import {MatButtonModule} from '@angular/material/button';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatSidenavModule} from '@angular/material/sidenav';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DocsMobiComponent } from './docs-mobi/docs-mobi.component';
import { DocsMenuComponent } from './docs-menu/docs-menu.component';
// import { FPXComponent } from './DocsContent/fpx/fpx.component';
// import { CommondatasService } from './shared/services/commondatas.service';
import { StoreModule } from '@ngrx/store';
import { regionReducer } from './shared/store/region.reducer';
import { HashLocationStrategy, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { RouterModule } from '@angular/router';
import { GetStartComponent } from './get-start/get-start.component';


@NgModule({
  declarations: [
    AppComponent,
    DocsMobiComponent,
    DocsMenuComponent,
    GetStartComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    BrowserAnimationsModule,
    StoreModule.forRoot({ region: regionReducer}),
  ],

  providers: [
    {provide: LocationStrategy, useClass: PathLocationStrategy}
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
